/**
 * Opengater pricing-settings hooks (users service, `admin: pricing-settings`).
 * One singleton row: GET reads it, PUT updates it.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
const PATH = '/api/v1/admin/pricing-settings';
export function useOgPricing() {
    return useQuery({
        queryKey: ['og', 'pricing'],
        queryFn: () => apiOg('users', PATH),
    });
}
export function useUpdateOgPricing() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (patch) => apiOg('users', PATH, { method: 'PUT', body: patch }),
        onSuccess: (data) => {
            // The PUT returns the full updated row — seed the cache with it so the
            // form reflects the server's canonical values immediately.
            qc.setQueryData(['og', 'pricing'], data);
        },
    });
}
